import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    doctorAudience, formatDate, formatFullDate, toPascalCase,
} from '../../../../utils';
import { DoctorPhoto } from '../../../../components/DoctorPhoto/DoctorPhoto';
import { DoctorDescription } from './DoctorDescription/DoctorDescription';
import { DoctorRegistry } from './DoctorRegistry/DoctorRegistry';
import { selectDate, selectDoctor } from '../../../store/serviceSlice';
import { TimeDiff, TimeslotList } from './TimeslotList/TimesotList';
import {
    getSelectedDate,
    getSelectedDoctor,
    getSelectedService,
    getServiceDoctorPhotos,
    getTimetableForCurrentDoctor,
} from '../../../store/selectors';
import { getActualTimeslotsObj, isFutureTimeslot } from '../../../util/timeSlots';
import { REGISTRY_NAME } from '../../../../features/doctors/DoctorItem';

const doctorItem = require('b_').with('doctor-item');
const link = require('b_').with('link');

const NearestTimeslot = React.memo(({
    nearestTimeslot, freeTimeslots = [], onDate, onRegistry,
}) => {
    const shouldRenderNearestTimeslot = nearestTimeslot && freeTimeslots?.length === 0;
    const shouldRenderBookingNotAvailable = !nearestTimeslot && freeTimeslots?.length === 0;
    return (
        <>
            {!shouldRenderNearestTimeslot ? null : (
                <span className={doctorItem('desc', { 'nearest-date': true })}>
                    Ближайшая датa:{' '}
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span onClick={onDate} className={link()}>
                        {formatDate(nearestTimeslot)}
                        <TimeDiff/>
                    </span>
                </span>
            )}
            {shouldRenderBookingNotAvailable && (
                <span className={doctorItem('desc', { 'nearest-date': true })}>
                    Ближайшая датa:{' '}
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span className={doctorItem('normal')}>
                        {REGISTRY_NAME || 'В регистратуре'}
                    </span>
                </span>
            )}
        </>
    );
});
export const DoctorListItem = ({ doctorData }) => {
    const {
        fullName = '',
        specialityName,
        // children,
        // childrenAge,
        // adult,
        nearestTimeslot,
        freeTimeslots = [],
        doctorId,
        description,
        // assignments,
        // online,
        serviceMappings,
    } = doctorData ?? {};

    const { serviceId } = useSelector(getSelectedService);

    const slotDuration = serviceMappings?.find(e => e.serviceId === serviceId)?.duration;

    const [ photoLink, setPhotoLink ] = useState('');
    const [ showRegistry, setShowRegistry ] = useState(false);
    const photos = useSelector(getServiceDoctorPhotos);
    const [ actualTimeslots, setActualTimeslots ] = useState(freeTimeslots);
    const [ actualNearestTimeslot, setActualNearestTimeslot ] = useState(nearestTimeslot);
    const [ collapsedState, setCollapsedState ] = useState({ state: true });

    const timetable = useSelector(getTimetableForCurrentDoctor);
    const dispatch = useDispatch();

    const selectedDate = useSelector(getSelectedDate);
    const selectedDoctor = useSelector(getSelectedDoctor);

    useEffect(() => {
        setShowRegistry(false);
    }, [timetable]);

    useEffect(() => {
        setCollapsedState({ state: true });
    }, [selectedDate]);

    useEffect(() => {
        if (!selectedDoctor) {
            setCollapsedState({ state: true });
        }
    }, [selectedDoctor]);

    useEffect(() => {
        if (timetable && slotDuration) {
            const filtered = timetable?.filter(e => isFutureTimeslot(e.startTime));
            const result = getActualTimeslotsObj(filtered, slotDuration);
            setActualTimeslots(result?.freeTimeslots);
            if (result?.nearestTimeslot) {
                setActualNearestTimeslot(result?.nearestTimeslot);
            } else {
                setActualNearestTimeslot(nearestTimeslot);
            }
        } else {
            setActualTimeslots(freeTimeslots);
            setActualNearestTimeslot(nearestTimeslot);
        }
    }, [ timetable, freeTimeslots, nearestTimeslot ]);

    useEffect(() => {
        setPhotoLink(photos[doctorId]);
    }, [ doctorId, photos ]);

    const setSelectedDoctor = () => {
        dispatch(selectDoctor(doctorId));
    };

    const onRegistry = () => {
        setSelectedDoctor();
        setShowRegistry(prev => !prev);
    };

    const onDate = () => {
        dispatch(selectDate(formatFullDate(actualNearestTimeslot)));
        setSelectedDoctor();
    };

    // console.log('freeTimeslots', {
    //     fullName,
    //     freeTimeslots,
    //     actualTimeslots,
    //     timetable,
    // });

    return (
        <li className={doctorItem()}>
            <div className={doctorItem('intro', { main: true })}>
                <div className={doctorItem('container')}>
                    <div className={doctorItem('photo-container')}>
                        <DoctorPhoto photoLink={photoLink}/>
                    </div>
                </div>
                <div className={doctorItem('info')}>
                    <header className={doctorItem('info-header')}>
                        <h4 className={doctorItem('desc', { name: true })}>{fullName}</h4>
                    </header>
                    <main className={doctorItem('info-body')}>
                        <span className={doctorItem('desc')}>{toPascalCase(specialityName)}</span>
                        <span className={doctorItem('desc')}>
                            Принимает:{' '}
                            {doctorAudience({
                                ...(doctorData ?? {}),
                                childrenAge: doctorData?.childrenAge ?? doctorData?.children_age,
                                childrenAgeTo: doctorData?.childrenAgeTo ?? doctorData?.children_age_to,
                                adultAgeTo: doctorData?.adultAgeTo ?? doctorData?.adult_age_to,
                                adultAge: doctorData?.adultAge ?? doctorData?.adult_age,
                            })}
                        </span>
                    </main>
                </div>
            </div>
            <div className={doctorItem('intro')}>
                <DoctorDescription description={description}/>
                <NearestTimeslot
                    nearestTimeslot={actualNearestTimeslot}
                    freeTimeslots={actualTimeslots}
                    onDate={onDate}
                    onRegistry={onRegistry}
                />
                <TimeslotList
                    timeslots={actualTimeslots}
                    doctorId={doctorId}
                    slotDuration={slotDuration}
                    collapsed={collapsedState}
                />
                <DoctorRegistry showRegistry={showRegistry}/>
            </div>
        </li>
    );
};
